import Layout from "../components/utils/layout";
import React from "react";
import Formatters from "../components/utils/formatters";


const BasicViews = () => {
    const screenId="BasicViews"
    const formatters = Formatters()
    const charts = {
        orders:{
            specialFormatters : {
                date_trunc:formatters.isoDate,
                count:formatters.int
            }
        },
        accounts:{
            specialFormatters : {
                date_trunc:formatters.isoDate,
                count:formatters.int
            }
        },
        subscriptions_created_vs_cancelled:{
            specialFormatters : {
                date_trunc:formatters.isoDate,
                count:formatters.int,
                prepaid_account_count:formatters.int,
                subscription_count:formatters.int
            }
        },
        order_by_status : {
            specialFormatters : {
                date: formatters.isoDate,
                count: formatters.int
            }
        },
        cardorder : {},
        replacement_fees : {},
        cards_issued_by_design : {},
        cards : {},
        peer_transfers : {
            source:"live"
        },
        new_gifters: {
            source:"live"
        },
        active_children_by_age: {
            source:"redshift",
            specialFormatters : {
                child_age: formatters.int,
                presentments_count_between_dates: formatters.int
            }
        },
        active_parents_by_age: {
            source:"redshift",
            specialFormatters : {
                parent_age: formatters.int,
                presentments_count_between_dates: formatters.int
            }
        },
        spends_by_merchant: {
            source:"redshift",
            specialFormatters : {
                trx_count: formatters.int
            }
        },
        account_lifecycle_summary: {
            specialFormatters : {
                account_id: formatters.account_id_link,
                account_created_date: formatters.isoDate,
                first_topup_date: formatters.isoDateTime,
                first_transaction_date: formatters.isoDateTime,
                last_transaction_date: formatters.isoDateTime,
                number_of_children: formatters.int,
                parent_age: formatters.int,
                total_transaction_count: formatters.int
            }
        }
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default BasicViews
